// Single registry for every persisted-storage key the app owns.
// Rule: a key that is read or written from more than one file MUST live here;
// keys used inside a single Vuex module may stay inline there.

/** localStorage — auth/session **/
export const AUTH_TOKEN = 'auth.token';
export const APP_VERSION = 'version';
export const UI_LANG = 'ui.lang';

/** localStorage — cached statistics (written by the athlete/dietPlan modules,
 *  checked raw by the statistics views) **/
export const ATHLETES_STATISTICS = 'athletes.statistics';
export const DIET_PLANS_STATISTICS = 'dietPlans.statistics';

/** localStorage — one-shot flags **/
export const FOOD_UPDATE_REQUIRED = 'food.foodUpdateRequired';

/** localStorage — kept on logout **/
// Pre-release features switched on in this browser.
export const FEATURE_FLAGS = 'featureFlags';
export const GOOGLE_SYNC_NOTICE_SEEN = 'calendar.googleSyncNoticeSeen';

/** localStorage — UI preferences **/
export const PROGRESS_LIST_TOGGLE = 'ui.progressListToggle';
export const HIDDEN_PHONE_NUMBER = 'ui.hiddenPhoneNumber';
export const KEEP_FEELINGS_TOGGLED = 'ui.keepFeelingsToggled';
export const FOOD_MODAL_LIST = 'ui.foodModalList';
export const QUESTIONNAIRE_AVOIDED_COLLAPSED = 'ui.questionnaireAvoidedCollapsed';
export const QUESTIONNAIRE_LIKED_COLLAPSED = 'ui.questionnaireLikedCollapsed';
export const SELECTED_TOOL = 'tools.selectedTool';
export const ATHLETE_LIST_LAYOUT_OPTIONS = 'layoutOptions';
export const QUESTIONNAIRE_PRINT_OPTIONS = 'questionnaires.printOptions';
export const MEASUREMENTS_PRINT_COLOR = 'measurements.print.color';
export const WIDGET_CUSTOMER_EMAIL = 'widget.customer_email';
export const COMMAND_PALETTE_RECENT_CLIENTS = 'commandPalette.recentClients';

/** localStorage — calendar preferences **/
export const CALENDAR_VIEW = 'calendar.view';
export const CALENDAR_SHOW_TIME = 'calendar.showTime';
export const CALENDAR_SHOW_GOOGLE = 'calendar.showGoogle';
export const CALENDAR_CATEGORY_FILTERS = 'calendar.categoryFilters';

/** localforage — PATHISIS **/
export const PATHISIS_CATEGORIES = 'pathisis.categories';
export const PATHISIS_SELECTED_CATEGORY = 'pathisis.selected_category';
export const PATHISIS_ALL_ITEMS = 'pathisis.all_items';
export const PATHISIS_SEARCH_INDEX = 'pathisis.search_index';
export const PATHISIS_LAST_UPDATE = 'pathisis.last_update';

/** localforage — FOODS **/
export const FOODS_LIST = 'food.foods';
export const FOODS_DRI = 'food.dris';
export const FOODS_COPIED_MEAL_ID = 'food.copied_meal_id';
export const FOODS_COPIED_DAY = 'food.copiedDay'
export const FOODS_COPIED_MEAL_TYPE = 'food.copiedMealType'

/** localforage — mobile feed **/
export const MOBILE_FEED_LATEST_STAMP = 'mobile.feed.latest_created_at_stamp';
export const MOBILE_FEED_LAST_FETCH = 'mobile.feed.last_fetch';
export const MOBILE_FEED_DATA = 'mobile.feed.data';
export const SHOW_MOBILE_NOTIFICATION_FEED = 'mobile.feed.show_notification_feed';
